export const CHAT_ID = "CHAT_ID";

export const chatId = (data) => {
  //   console.log(data);
  return {
    type: CHAT_ID,
    data,
  };
};
